import { render } from "./AdminTicketsView.vue?vue&type=template&id=c558b2f6&scoped=true"
import script from "./AdminTicketsView.vue?vue&type=script&lang=js"
export * from "./AdminTicketsView.vue?vue&type=script&lang=js"

import "./AdminTicketsView.vue?vue&type=style&index=0&id=c558b2f6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c558b2f6"]])

export default __exports__